export default `
§ uiKit.console.button: Kopieren
§ uiKit.console.notification: Der Text wurde kopiert
§ uiKit.dataLoader.page: Seite
§ uiKit.dataLoader.size: Wird nach angezeigt
§ uiKit.dataLoader.from: aus
§ uiKit.dataLoader.all: Alles anzeigen
§ uiKit.hoursChart.work: normale Arbeitszeit (wochentags von 07:00 bis 20:00 Uhr)
§ uiKit.hoursChart.weekend: wochenenden oder Zeit vor/nach dem Arbeitstag
§ uiKit.hoursChart.days: gesamtzahl der Commits für die gesamte Zeit an einem bestimmten Tag und einer bestimmten Stunde
§ uiKit.page.remove: Entfernen
§ uiKit.nothingFound.common.title: Es gibt keine oder nicht genügend Daten zum Anzeigen
§ uiKit.nothingFound.common.description: Das System verarbeitet mehr Daten, wenn die Commits im Format signiert werden [Git commit message convention|https://www.conventionalcommits.org/en/v1.0.0/]. Vorlage:
§ uiKit.nothingFound.common.console: Aufgabennummer Typ(Module): Erläuterung
§ uiKit.nothingFound.common.example: Zum Beispiel:
§ uiKit.nothingFound.staff.title: Keine Daten für diesen Mitarbeiter
§ uiKit.nothingFound.staff.description1:
Er hat nicht an allen Werktagen Änderungen vorgenommen. Deshalb erhielt er den Status "Assistent".
Die Statistiken eines Mitarbeiters mit diesem Status können nicht berücksichtigt werden. Sein Beitrag ist gering.
§ uiKit.nothingFound.staff.description2:
Das System berechnet für ihn keine Anzahl von Indikatoren.
Wenn dies ein Fehler ist und die Statistiken für diesen Mitarbeiter berücksichtigt werden müssen, gehen Sie zu «Einstellungen» und ändern Sie den Typ des Mitarbeiters.
§ common.title: Git Statistik
§ common.filters: Filter
§ common.notifications.save: Änderungen gespeichert
§ common.notifications.setting: Einstellungen gespeichert
`;
